import type { ProductImageEntry } from "./types";

const use = ["pages/Plattform.tsx"] as const;

export const REPORT_DETAIL_REMAINDER_CATALOGUE: readonly ProductImageEntry[] = [
  {
    id: "report.section-unassigned",
    module: "Rapport · Otilldelade besök",
    area: "solution",
    opens: "Schema → rapport → Varför blir besök kvar?",
    setup: [
      "Öppna den sparade flex-15-rapporten för den accepterade Carefox-perioden",
      "Visa den valda lösningens uppmätta fördelning av otilldelade besök",
    ],
    scenario: "S2",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Rapportens förklaring av otilldelade besök i den valda lösningen",
        shows:
          "Rapporten visar hur det valda förslaget delar upp besök som inte tilldelats.",
        proves:
          "Fördelningen läses från flex-15-lösningens sparade rapport för den accepterade Carefox-perioden.",
      },
      en: {
        alt: "The report's explanation of unassigned visits in the selected solution",
        shows:
          "The report shows how the selected proposal partitions visits that remain unassigned.",
        proves:
          "The breakdown comes from the saved report for the flex-15 solution and accepted Carefox period.",
      },
    },
    use,
  },
  {
    id: "report.section-example-day",
    module: "Rapport · Exempeldag",
    area: "solution",
    opens: "Schema → rapport → Exempeldag",
    setup: [
      "Öppna den sparade flex-15-rapporten för den accepterade Carefox-perioden",
      "Fortsätt bara när rapporten innehåller en tidslinje med planerade block",
    ],
    scenario: "S2",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Rapportens tidslinje för en dag med sparade planeringsdata",
        shows:
          "Tidslinjen visar planerade block för rapportens valda exempeldag.",
        proves:
          "Dagens innehåll kommer från rapportens sparade exempeldata för flex-15.",
      },
      en: {
        alt: "The report timeline for a day with saved planning data",
        shows:
          "The timeline shows planned blocks for the report's selected example day.",
        proves:
          "The day's content comes from the saved example data for flex-15.",
      },
    },
    use,
  },
  {
    id: "report.share-actions",
    module: "Rapport · Utskrifts- och Excel-val",
    area: "solution",
    opens: "Schema → rapportbyggare → Dela",
    setup: [
      "Öppna rapportbyggaren för den sparade flex-15-rapporten",
      "Visa sidantalet samt rapportens utskrifts- och Excel-knappar",
    ],
    scenario: "S2",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Rapportbyggarens sidantal och val för utskrift och Excel",
        shows:
          "Rapportbyggaren visar sidantalet och de tillgängliga utskrifts- och Excel-knapparna.",
        proves:
          "Vyn visar exportval i den sparade rapporten; den bekräftar inte att en fil har skapats.",
      },
      en: {
        alt: "The report builder's page count and print and Excel actions",
        shows:
          "The report builder shows its page count and the available print and Excel actions.",
        proves:
          "This view shows export controls for the saved report; it does not confirm that a file was created.",
      },
    },
    use,
  },
];
